import VForm from '@/vuetify_custom/v-form'
import { VCard, VCardTitle, VCardText } from 'vuetify/lib'
// import EditAttachments from '@/views/components/file/edit_attachments_v1';
// import FileUploader from '@/views/components/file/uploader.vue';
import { commonValidateRule } from '../utils'
import { common_mixins } from './EditMixIns.jsx'
import styles from './index.module.less'
const commonValidateRuleGo = commonValidateRule('必选')
export default {
    mixins:[common_mixins],
    computed: {
        contract_types_filter() {
          // const {main_type} = this.params
            return this.contract_types
        },
        fields() {
            return [
                {
                    label: '',
                    key:'cost_allocation',
                    type:'checkbox',
                    cols: 3,
                    scopedSlots: {
                        prepend:() => {
                            return <p class={styles['p-no']} style="width:70px;line-height: 24px;">是否摊销</p>
                        },
                 
                    }
                },
                {
                    type: 'empty',
                    cols: 8,
                },
                {
                    label: '账单生成方式',
                    key:'bill_generate_type',
                    type:'autocompletes',
                    'item-value':'key',
                    'item-text':'name', // 'name',
                    clearable: true,
                    required: true,
                    items: [
                        {
                            key: 'no_need',
                            name: '无需提供账单'
                        },
                        {
                            key: 'self_submit',
                            name: '业务提供账单'
                        },
                        {
                            key: 'expense_group',
                            name: '付款生成账单'
                        }
                    ],
                    cols: 3,
                    rules:[commonValidateRuleGo],
                },
                {
                    label: '合同/付款/发票提交时，团队为中后台团队，计提费用时，拆分到实际使用团队',
                    key:'need_split_expense',
                    type:'checkbox',
                    cols: 12,
                    scopedSlots: {
                        prepend:() => {
                            return <p class={styles['p-no']} style="width:80px;line-height: 24px;">需拆分费用</p>
                        },
                 
                    }
                },
                // {
                //     cols:8,
                //     key: 'upload'
                // }
               
             ]
        }
    },
    methods: {
    },
    render() {
        const _this = this
        return <div class={styles['block-margin']}>
        <VCard flat light outlined>
            <VCardTitle>
                财务
            </VCardTitle>
            <VCardText>
            <VForm
                ref="base"
                fields={_this.fields}
                v-model={_this.params}
                scopedSlots={{
                    /* upload:() => {
                        return <div style="display:flex">
                            <p style="width:40px">
                                附件
                            </p>
                            <div style="flex:1">
                                <EditAttachments
                                    files={_this.params.bfiles}
                                    modelType="Contract"
                                    modelId={_this.params.id}
                                    />
                                    <FileUploader on={{
                                        uploaded: (bfile) => {
                                            _this.params.bfiles.push(bfile)
                                        }
                                    }}/>
                                    <span class="color-error">为保证兼容性及文档可编辑性，请上传office系列的文档(Word, Excel, PPT)</span>
                            </div>
                        </div>
                    } */
                }}
            />
            </VCardText>
        </VCard>
    </div>
    }
}